import CommunicationForm from './CommunicationForm';

export default CommunicationForm;